<template>
  <b-modal
    v-model="showModal"
    size="xl"
    centered
    scrollable
    body-class="p-0"
    header-class="py-3"
    footer-class="d-none"
    @hidden="onHidden"
  >
    <template #modal-header="{ close }">
      <div class="d-flex align-items-center justify-content-between w-100">
        <div v-if="planStructure">
          <span class="text-muted text-uppercase small font-weight-bold">{{ levelLabel }}</span>
          <h5 class="mb-0 mt-1">{{ planStructure.name }}</h5>
        </div>
        <b-button variant="link" class="p-0 ml-auto" @click="close">
          <font-awesome-icon :icon="['fas', 'times']" class="fa-lg" />
        </b-button>
      </div>
    </template>

    <div v-if="loading" class="p-5 text-center text-muted">
      Carregando...
    </div>

    <div v-else-if="planStructure" class="modal-level-content">
      <b-tabs
        v-model="activeTab"
        pills
        lazy
        align="center"
        nav-class="pill-tabs mx-auto mb-3"
        nav-wrapper-class="d-flex px-3 pt-2"
      >
        <template #tabs-end>
          <div class="position-absolute right-button mr-4">
            <b-button
              v-show="showDraggableButton"
              pill
              variant="outline-secondary"
              size="sm"
              v-b-tooltip.hover
              title="Reordenar listagem"
              class="border-0"
              @click="$bvModal.show('modal-level-draggable-measures')"
            >
              <b-icon icon="gear"></b-icon>
            </b-button>
          </div>
        </template>
        <b-tab title="Metas" title-link-class="rounded-pill px-5">
          <div class="px-3 pb-4">
            <list-goals :plan-structure-id="planStructureId" />
          </div>
        </b-tab>
        <b-tab title="Indicadores" title-link-class="rounded-pill px-5">
          <div class="px-3 pb-4">
            <list-indicators :plan-structure-id="planStructureId" />
          </div>
        </b-tab>
      </b-tabs>

      <modal-draggable
        v-if="planStructure && planStructure.measures"
        title="Ordenar Metas"
        :items="planStructure.measures || []"
        id="modal-level-draggable-measures"
        @order="orderMeasuresById"
      />
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import services from "@/http";

import ListGoals from "@/modules/objectives/components/ListGoals.vue";
import ListIndicators from "@/modules/objectives/components/ListIndicators.vue";
import ModalDraggable from "@/components/modal/ModalDraggable";

export default {
  name: "ModalShowLevel",
  components: {
    ModalDraggable,
    ListGoals,
    ListIndicators,
  },
  data: () => ({
    showModal: false,
    loading: false,
    planStructure: null,
    planStructureId: null,
    strategicPlanId: null,
    activeTab: 0,
  }),
  computed: {
    levelLabel() {
      return "Nível do Plano";
    },
    showDraggableButton() {
      return (
        this.activeTab === 0 &&
        this.planStructure?.measures &&
        this.planStructure.measures.length > 1
      );
    },
  },
  methods: {
    show(planStructureId, strategicPlanId = null) {
      this.planStructureId = planStructureId;
      this.strategicPlanId = strategicPlanId;
      this.showModal = true;
      this.activeTab = 0;
      this.loadData();
    },
    onHidden() {
      const spId = this.planStructure?.strategic_plan_id || this.strategicPlanId;
      this.planStructure = null;
      this.planStructureId = null;
      this.strategicPlanId = null;
      this.$emit("closed", spId);
    },
    async orderMeasuresById(measures) {
      try {
        await services.strategic_plans.plan_structure_order_measures(
          { id: this.planStructureId },
          measures
        );
        this.$notifications.addNotification({
          message: "Ordem alterada com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao salvar",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
    async loadData() {
      if (!this.planStructureId) return;
      this.loading = true;
      try {
        const res = await services.strategic_plans.plan_structure_detail({
          id: this.planStructureId,
        });
        this.planStructure = res.data;
      } catch (e) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados do nível.",
          type: "danger",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.modal-level-content {
  min-height: 300px;
}

::v-deep .pill-tabs {
  border: 1px solid #d4e0ed;
  border-radius: 30px;
}

::v-deep .rounded-pill {
  border-radius: 20px !important;
}

.right-button {
  right: 0;
  top: 2px;
}
</style>
